<script>
    export default {
        functional: true,

        render: function (createElement, context) {
            const getHeight = (el, margins = false) => {
                let height = el.offsetHeight + 2

                if (margins) {
                    height += getComputedStyle(el).getPropertyValue('marginTop')
                    height += getComputedStyle(el).getPropertyValue('marginBottom')
                }

                return height + "px"
            }

            var data = {
                props: {
                    name: 'panel-transition',
                    css: false
                },

                on: {
                    enter(el, done) {
                        el.style.opacity = 0

                        $(el.parentElement).animate(
                            {
                                height: getHeight(el)
                            },
                            300,
                            'swing',
                            done
                        );
                    },

                    afterEnter(el) {
                        el.style.opacity = 1
                        el.parentElement.removeAttribute('style')
                    },

                    beforeLeave(el) {
                        el.parentElement.style.height = getHeight(el)
                    },

                    leave(el, done) {
                        $(el).animate({
                                opacity: 0
                            },
                            300,
                            'swing',
                            done
                        );
                    },
                }
            }

            return createElement('transition', data, context.children)
        }
    }
</script>
